import React from 'react'

import { ChatChoiceActionMetadata } from 'generated/types'

import { DateDivider } from './DateDivider'
import { ResponseMessage } from './ResponseMessage'
import { SentMessage } from './SentMessage'
import { Message, RatingMutationPayload } from './utils/types'

export const MessageList = ({
  messageOrder,
  messages,
  onRateResponse,
  onCloseAssistant,
  sessionId,
  onSendMessage,
  isTyping,
}: {
  messageOrder: string[]
  messages: Record<string, Message>
  onRateResponse: ({ messageId, rating }: RatingMutationPayload) => void
  onCloseAssistant: () => void
  sessionId: string
  onSendMessage: (message: string, metadata?: ChatChoiceActionMetadata) => void
  isTyping: boolean
}) => {
  return (
    <>
      {messageOrder.map((id) => {
        const message = messages[id]
        if (!message) {
          return null
        }

        if (message.messageType === 'DateDivider') {
          return <DateDivider key={id} date={message.text} />
        }

        return message.messageType === 'SentMessage' ? (
          <SentMessage key={id} message={message} />
        ) : (
          <ResponseMessage
            key={id}
            message={message}
            onRateResponse={onRateResponse}
            onCloseAssistant={onCloseAssistant}
            sessionId={sessionId}
            onSendMessage={onSendMessage}
            isTyping={isTyping}
          />
        )
      })}
    </>
  )
}
